import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import './styles/common.scss'
import './styles/index.scss'
import "./assets/icon/iconfont.css"
import BaseContainer from "./components/BaseContainer"
import ArtisanGroup from "./components/ArtisanGroup"
import ArtisanCalendar from "./components/ArtisanCalendar"
import ArtisanDialog from "./components/ArtisanDialog"
import ArtisanDrawer from "./components/ArtisanDrawer"
import ArtisanMsgBox from "./components/ArtisanMsgBox"
import ArtisanForm from "./components/ArtisanForm/index"
import ArtisanSelect from "./components/ArtisanForm/ArtisanSelect"
import ArtisanGrid from "@/components/ArtisanGrid"
import { hiPrintPlugin } from 'vue-plugin-hiprint'
import jquery from 'jquery'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import Storage from 'vue-ls'
let options = {
  namespace: 'hiPrint-',
  name: 'ls',
  storage: 'local',
};
Vue.use(Storage, options);

Vue.use(Antd);
// hiPrintPlugin.disAutoConnect() // 取消自动连接直接打印客户端，如果设置了取消自动连接，后续是获取不到打印机列表的
Vue.use(hiPrintPlugin, '$pluginName')
Vue.prototype.$ = jquery
import VCalendar from 'v-calendar';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VCalendar);
Vue.component('BaseContainer', BaseContainer);
Vue.component('ArtisanCalendar', ArtisanCalendar);
Vue.component('ArtisanGroup', ArtisanGroup);
Vue.component('ArtisanDialog', ArtisanDialog);
Vue.component('ArtisanDrawer', ArtisanDrawer);
Vue.component('ArtisanMsgBox', ArtisanMsgBox);
Vue.component('ArtisanForm', ArtisanForm);
Vue.component('ArtisanSelect', ArtisanSelect);
Vue.component('ArtisanGrid', ArtisanGrid);


// const componentsContext = require.context('./components/question', true, /\.vue$/);
// componentsContext.keys().forEach(file_name => {
//   // 获取文件中的 default 模块
//   const componentConfig = componentsContext(file_name).default;
//   Vue.component(componentConfig.name, componentConfig);
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')